import Button from '../../../ui_components/button/button';
import ValidationForm, { FormValidationError } from '../../../ui_components/validation/validationForm';
import { ValidationPopupInput } from '../../../ui_components/validation/validationPopupInput';
import { PopoverScrollContext } from '../../../ui_components/popover/popover';
import {
  Modal,
  ModalActions,
  ModalHeader,
} from '../../../ui_components/modal';
import PageDimmer from '../../../ui_components/dimmer/PageDimmer';
import { ClientPricingAction, PricingType } from '../types';
import {
  DraperyItemDetailsFieldsPartial,
  draperyItemDetailsFieldsInitialState,
  draperyItemDetailsFieldsReducer,
} from '../../../redux/modules/my-shop/drapery-item-details-fields-reducer';
// import { ConfirmationCloseModal } from "../../../modals/confirmation_close_modal";
import {
  FormFieldsPartial,
  formFieldsInitialState,
  formFieldsReducer,
} from '../../../redux/modules/my-shop/form-fields-reducer';
import { ItemModalContent, ItemTabs, TabContainer } from '../styles';
import React, {
  FC,
  FormEvent,
  KeyboardEvent,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import { Tab, TabList } from 'react-tabs';
import { addDraperyRecord, getDraperyRecord, updateDraperyRecord } from '../../../api/item';
import { draperyPricingTypes, draperyWidthRoundUpTypes } from '../constants';
import styled, { theme } from '../../../theme';
import { useDispatch } from 'react-redux';
import { confirmation } from '../../../confirmation';
import { Category } from '../../../interfaces/category';
import { ConstructionSettings } from './construction-settings/main';
import Details from './details';
import { HelpPopup } from '../../content/help_popup';
import Pricing from './pricing';
import { Supplier } from '../../../interfaces/supplier';
import { detect } from 'detect-browser';
import { getSelectedName } from '../helpers';
import PricingAlert from '../../../assets/icons/pricingalert.svg';
import { Prompt } from 'react-router-dom';
import { trackView } from '../../analytics/track_view';
import { MixpanelEvents } from '../../analytics/mix_panel_events';

const CancelButton = styled(Button)`
  box-shadow: none !important;
`;

export const FormLabel = styled.label`
  color: ${theme.colors.grayRGBA};
  margin-bottom: 2px;

  .red-asterisk {
    color: ${theme.colors.red};
  }
`;

export const FormInput = styled(ValidationPopupInput)`
  padding: 0.35em 0.5em;
`;

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  margin-right: 30px !important;

  > label:hover,
  &:hover {
    cursor: pointer;
  }
`;

export const RadioInput = styled(ValidationPopupInput)`
  border-radius: 50%;
  width: 15px;
  height: 15px;
  font-size: 0;
  margin-right: 5px;
  border: 1px solid ${theme.colors.grayRGBA};
  border: ${(props) => (props.checked ? `5px solid ${theme.colors.blue}` : '')};

  input {
    visibility: hidden;
  }
`;

export const TextAreaContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  span {
    margin-top: 5px;
    margin-right: 10px;
  }

  .text-area {
    width: 100%;
    border: solid ${theme.colors.primary} 1px;
    height: 120px;
  }
`;

export const RightCell = styled.div`
  width: 50%;
  margin-bottom: 20px;
  padding-right: 1.25rem;
  padding-right: 0;
  padding-left: 1.25rem;
`;

export const RightCellWithBorder = styled(RightCell)`
  border-left: 1px solid ${theme.colors.blue};
`;

export const TooltipPopup = styled(HelpPopup)`
  max-width: 300px;
  max-height: 50%;
  display: flex !important;

  > svg {
    color: ${theme.colors.red1};
  }
`;
const ModalItem = styled(Modal)`
  width: 90%;
  min-height: 300px;
  bottom: 0px;
`;
const ValidationFormDrapery = styled(ValidationForm)`
  min-height: inherit;
`;
interface DraperyItemModalProps {
  isModalOpen: boolean;
  categories: Category[];
  suppliers: Supplier[];
  itemId: number | null;
  onModalClose(): void;
  reloadGrid(): void;
  validateAll?(mode: string): boolean;
  updateStateByName?(
    name: string,
    value: string | number | boolean | number[] | undefined | object,
    isSaving?: boolean
  ): void;
  isPleatModalOpen?: boolean;
  showDraperyModal?: boolean;
  history?: any;
  fetchAll(): void;
  tabIndex?: number;
  reloadOnSave?(): void;
  highLightInput?: string[];
  isEstimateSettingsReadOnly?: boolean;
}

interface ScrollInfo {
  scrollX: number;
  scrollY: number;
}

export type NewAddOn = {
  id: string;
  name: string;
  price: string;
};

export type NewAddOnError = {
  name: {
    active: boolean;
    message: string;
  };
  price: {
    active: boolean;
    message: string;
  };
};

const DraperyItemModal: FC<DraperyItemModalProps> = ({
  isModalOpen,
  categories,
  suppliers,
  itemId,
  onModalClose,
  reloadGrid,
  fetchAll,
  updateStateByName,
  isPleatModalOpen,
  showDraperyModal,
  history,
  tabIndex,
  reloadOnSave,
  highLightInput,
  isEstimateSettingsReadOnly,
}) => {
  const constructionDispatch = useDispatch();
  const constructionRef = useRef<any>(null);

  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [openNewAddOn, setOpenNewAddOn] = useState<boolean>(false);
  const [newAddOn, setNewAddOn] = useState<NewAddOn>({
    id: '',
    name: '',
    price: '',
  });
  const [newAddOnError, setNewAddOnError] = useState<NewAddOnError>({
    name: {
      active: false,
      message: '',
    },
    price: {
      active: false,
      message: '',
    },
  });
  const accountId = parseFloat(localStorage.getItem('accountId') || '0');
  const browser = detect();
  // const [isCloseModalActive, setIsCloseModalActive] =
  //     useState<boolean>(false);
  const [activeTabIndex, setActiveTabIndex] = useState<number>(tabIndex || 0);
  const [areaScrollInfo, setAreaScrollInfo] = useState<ScrollInfo>({
    scrollX: 0,
    scrollY: 0,
  });
  const [copyFormFields, copyDispatch] = useReducer(formFieldsReducer, formFieldsInitialState);
  const [formFields, dispatch] = useReducer(formFieldsReducer, formFieldsInitialState);
  const [copyDraperyItemDetailsFields, copyDispatchItemDetails] = useReducer(
    draperyItemDetailsFieldsReducer,
    draperyItemDetailsFieldsInitialState
  );
  const [draperyItemDetailsFields, dispatchItemDetails] = useReducer(
    draperyItemDetailsFieldsReducer,
    draperyItemDetailsFieldsInitialState
  );

  const [errorElementId, setErrorElementId] = useState<string | null>(null);

  const handleResetNewAddOnForm = () => {
    setNewAddOn({
      id: '',
      name: '',
      price: '',
    });
    setNewAddOnError({
      name: {
        active: false,
        message: '',
      },
      price: {
        active: false,
        message: '',
      },
    });
  };

  const handleInvalidElem = (elem: HTMLElement): void => {
    const elemId = elem.id;

    if (['name', 'itemCategory', 'itemTypeProduct', 'itemTypeService'].includes(elemId)) {
      setActiveTabIndex(0);
    } else {
      setActiveTabIndex(1);
    }

    setErrorElementId(elemId);
  };

  const saveConstructionSettings = async () => {
    if (!constructionRef.current) return false;

    const result = await constructionRef.current.saveCurrentSetting();
    return result;
  };

  const handleSubmitForm = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    if (isEstimateSettingsReadOnly) {
      return;
    }
    setErrorElementId(null);
    if (!isPleatModalOpen) {
      const { name, itemNumber, avatarId, itemTypeId, supplierId, categoryId, notes, isActive } =
        formFields;

      let payload: FormFieldsPartial = {
        name,
        itemNumber,
        avatarId,
        itemTypeId,
        supplierId,
        categoryId,
        notes,
        isActive,
      };

      const {
        pricingTypeId,
        isClientPricingActionOn,
        clientPricingAction,
        clientPricingValue,
        isPartialWidthRoundingOn,
        partialWidthRoundUpTypeId,
        pleatTypesWithPricing,
        liningAndInterliningWithPricing,
        cafeCurtainsWidthInches,
        cafeCurtainsWidthPricing,
        extraLargePanelsLengthInches,
        extraLargePanelsLengthPricing,
        extraLargePanelsWidthInches,
        extraLargePanelsWidthPricing,
        draperyPinningWidthPricing,
        specialityFabricsMarkUpPercentage,
        embellishmentsWithPricing,
        addOnsWithPricing,
        salesDescriptionSettings,
        orderingDescriptionSettings,
        patternMatchingUpcharges,
        patternMatchingUpchargesSelected,
        isBundlingSelected,
        bundleSelections,
      } = draperyItemDetailsFields;

      let detailsPayload: DraperyItemDetailsFieldsPartial = {
        pricingTypeId,
        isClientPricingActionOn,
        clientPricingAction,
        clientPricingValue,
        isPartialWidthRoundingOn,
        partialWidthRoundUpTypeId,
        pleatTypesWithPricing,
        liningAndInterliningWithPricing,
        cafeCurtainsWidthInches,
        cafeCurtainsWidthPricing,
        extraLargePanelsLengthInches,
        extraLargePanelsLengthPricing,
        extraLargePanelsWidthInches,
        extraLargePanelsWidthPricing,
        draperyPinningWidthPricing,
        specialityFabricsMarkUpPercentage,
        embellishmentsWithPricing,
        addOnsWithPricing,
        salesDescriptionSettings,
        orderingDescriptionSettings,
        patternMatchingUpcharges,
        patternMatchingUpchargesSelected,
        isBundlingSelected,
        bundleSelections,
      };
      let comboPayload = {
        ...payload,
        ...detailsPayload,
      };
      if (updateStateByName) {
        for (const key in detailsPayload) {
          if (
            [
              'pricingTypeId',
              'clientPricingAction',
              'clientPricingValue',
              'partialWidthRoundUpTypeId',
              'pleatTypesWithPricing',
              'liningAndInterliningWithPricing',
              'cafeCurtainsWidthInches',
              'cafeCurtainsWidthPricing',
              'extraLargePanelsLengthInches',
              'extraLargePanelsLengthPricing',
              'extraLargePanelsWidthInches',
              'extraLargePanelsWidthPricing',
              'draperyPinningWidthPricing',
              'specialityFabricsMarkUpPercentage',
              'embellishmentsWithPricing',
              'addOnsWithPricing',
              'salesDescriptionSettings',
              'orderingDescriptionSettings',
              'patternMatchingUpcharges',
              'patternMatchingUpchargesSelected',
              'isBundlingSelected',
              'bundleSelections',
            ].includes(key)
          ) {
            updateStateByName(`draperyItemDetail.0.${key}`, detailsPayload[key]);
          }
        }
      }

      if (updateStateByName) {
        for (const key in detailsPayload) {
          if (
            [
              'pricingTypeId',
              'clientPricingAction',
              'clientPricingValue',
              'partialWidthRoundUpTypeId',
              'pleatTypesWithPricing',
              'liningAndInterliningWithPricing',
              'cafeCurtainsWidthInches',
              'cafeCurtainsWidthPricing',
              'extraLargePanelsLengthInches',
              'extraLargePanelsLengthPricing',
              'extraLargePanelsWidthInches',
              'extraLargePanelsWidthPricing',
              'draperyPinningWidthPricing',
              'specialityFabricsMarkUpPercentage',
              'embellishmentsWithPricing',
              'addOnsWithPricing',
              'salesDescriptionSettings',
              'orderingDescriptionSettings',
              'patternMatchingUpcharges',
              'patternMatchingUpchargesSelected',
              'isBundlingSelected',
              'bundleSelections',
            ].includes(key)
          ) {
            updateStateByName(`draperyItemDetail.0.${key}`, detailsPayload[key]);
          }
        }
      }

      let result: any;

      if (itemId) {
        comboPayload = {
          ...comboPayload,
          id: itemId,
        };
        result = await updateDraperyRecord(comboPayload);

        trackView(MixpanelEvents.SAVE_FABRICATION, { order_type: 'drapery' });
      } else {
        result = await addDraperyRecord(comboPayload);
      }

      const constructionSaved = await saveConstructionSettings();

      await fetchAll();

      const errors = result.data.errors;
      const status = result.status;

      if (errors) {
        setAreaScrollInfo({
          scrollX: 0,
          scrollY: 0,
        });
        throw FormValidationError.fromErrorDictionary(errors);
      } else if (!constructionSaved) {
        setActiveTabIndex(2);
        setErrorElementId('errorMessage');
      } else if ([201, 200].includes(status)) {
        if (reloadOnSave) {
          reloadOnSave();
        }
        onSaveClose();
        if (showDraperyModal && history) {
          localStorage.removeItem('draperyItem');
          history.push('/calculator');
        }
        reloadGrid();
      }
    }
  };

  const deepEqual = (obj1: any, obj2: any): boolean => {
    if (obj1 === obj2) return true;

    if (obj1 == null || obj2 == null) return false;

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) return false;
    }

    return true;
  };

  const handleKeyPressForm = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
    }
  };

  const selectTab = (index: number) => {
    if (isEstimateSettingsReadOnly && index !== 0) {
      return false;
    }
    setActiveTabIndex(index);
    setAreaScrollInfo({
      scrollX: 0,
      scrollY: 0,
    });
    return true;
  };

  // const onClose = () => {
  //     dispatch({ type: "resetFormFields" });
  //     setActiveTabIndex(0);
  //     onModalClose();
  // };

  const handleOpenNewAddOn = (val: boolean) => {
    setOpenNewAddOn(val);
  };

  const handleCreateNewAddOn = async () => {
    if (!newAddOn.id || !newAddOn.name || !newAddOn.price) {
      setNewAddOnError((prev) => {
        return {
          ...prev,
          name: {
            active: !newAddOn.name,
            message: 'Name is missing',
          },
          price: {
            active: !newAddOn.price,
            message: 'Price is missing',
          },
        };
      });
      return;
    }

    const new_add_ons = [...draperyItemDetailsFields['addOnsWithPricing']];

    if (new_add_ons.some((i) => i.name === newAddOn.name.trim())) {
      setNewAddOnError((prev) => {
        return {
          ...prev,
          name: {
            active: true,
            message: 'Name is already in use',
          },
        };
      });
      return;
    } else {
      new_add_ons.push({
        id: newAddOn.id,
        name: newAddOn.name.trim(),
        price: newAddOn.price
      });
    }

    setNewAddOnError({
      name: {
        active: false,
        message: '',
      },
      price: {
        active: false,
        message: '',
      },
    });

    dispatchItemDetails({
      type: 'updateFormFields',
      formFieldUpdates: {
        addOnsWithPricing: new_add_ons,
      },
    });
    
    const response = true;

    if (response) {
      handleResetNewAddOnForm();
      handleOpenNewAddOn(false);
    }
  };

  const handleCancelNewAddOn = () => {
    handleResetNewAddOnForm();
    handleOpenNewAddOn(false);
  };

  const handleNewAddOnForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;
    const priceRegex = /^(0|0\.\d{0,2}|[1-9]\d{0,2}(\.\d{0,2})?)$/;

    if (name === 'price') {
      if (value.startsWith('.')) value = `0${value}`;
      if (value && !priceRegex.test(value)) return;
    }

    const unique_id = value ? value.split(' ').join('_').toLowerCase() : '';

    setNewAddOn((prev) => ({ ...prev, id: name === 'name' ? unique_id : prev.id, [name]: value }));
    setNewAddOnError((prev) => {
      return {
        ...prev,
        [name]: {
          active: false,
          message: ''
        }
      }
    });
  };

  const showEditWorkOrderConfirm = (): Promise<boolean> => {
    return confirmation(<div>Would you like to cancel your edits?</div>, {
      uiHeader: 'Confirmation',
      uiAcceptLabel: 'No, continue editing',
      uiDeclineLabel: 'Yes, cancel edits',
      workOrderEditMode: true,
      cancelEditing: () => {
        onModalClose();
        trackView(MixpanelEvents.CANCEL_EDIT_FABRICATION, { order_type: 'drapery' });
      },
    });
  };

  const onClose = () => {
    if (isEstimateSettingsReadOnly) {
      dispatch({ type: 'resetFormFields' });
      setActiveTabIndex(0);
      onModalClose();
      return;
    }

    if (
      deepEqual(formFields, copyFormFields) &&
      deepEqual(draperyItemDetailsFields, copyDraperyItemDetailsFields) &&
      !isChanged
    ) {
      // setIsCloseModalActive(false);
      dispatch({ type: 'resetFormFields' });
      setActiveTabIndex(0);
      onModalClose();

      trackView(MixpanelEvents.CANCEL_EDIT_FABRICATION, { order_type: 'drapery' });
    } else {
      // setIsCloseModalActive(true);
      showEditWorkOrderConfirm();
    }
  };

  const onSaveClose = () => {
    dispatch({ type: 'resetFormFields' });
    setActiveTabIndex(0);
    onModalClose();
    history.push(`/calculator`, { type: history.location.state.type, from: 'myshop' });
    // history.push("/calculator");
  };

  const renderDetails = (): JSX.Element => {
    return (
      <TabContainer>
        <Details
          categories={categories}
          suppliers={suppliers}
          browser={browser}
          formFields={formFields}
          dispatch={dispatch}
          copyDispatch={copyDispatch}
          draperyItemDetailsFields={draperyItemDetailsFields}
          dispatchItemDetails={dispatchItemDetails}
          isEstimateSettingsReadOnly={isEstimateSettingsReadOnly}
        />
      </TabContainer>
    );
  };

  const renderPricing = (): JSX.Element => {
    return (
      <TabContainer>
        <Pricing
          browser={browser}
          draperyItemDetailsFields={draperyItemDetailsFields}
          dispatch={dispatchItemDetails}
          itemId={itemId}
          formFields={formFields}
          highLightInput={highLightInput}
          openNewAddOn={openNewAddOn}
          newAddOn={newAddOn}
          newAddOnError={newAddOnError}
          handleCreateNewAddOn={handleCreateNewAddOn}
          handleCancelNewAddOn={handleCancelNewAddOn}
          handleOpenNewAddOn={handleOpenNewAddOn}
          handleNewAddOnForm={handleNewAddOnForm}
        />
      </TabContainer>
    );
  };

  const renderConstructionSettings = (): JSX.Element => {
    return (
      <TabContainer>
        <ConstructionSettings
          dispatch={constructionDispatch}
          setIsChanged={setIsChanged}
          accountId={accountId}
          ref={constructionRef}
        />
      </TabContainer>
    );
  };

  const getModalTitle = (): JSX.Element | '' => {
    const { categoryName, name } = formFields;

    if (!categoryName && !name) {
      return <span className="text-twPrimary font-medium">Add New Item</span>;
    }

    return (
      <div>
        {categoryName && (
          <>
            <span className="text-twBlue">{categoryName}</span>
            <span className="p-1">|</span>
          </>
        )}
        <span className="text-twBlue">{`${name || ''}`}</span>
      </div>
    );
  };

  useEffect(() => {
    if (itemId) {
      getDraperyRecord({ recordId: itemId })
        .then((res) => {
          const { pleatTypesWithPricing } = res;
          const itemUpdates: FormFieldsPartial = {
            ...res,
            pleatTypesWithPricing: pleatTypesWithPricing || [],
          };
          const draperyItemDetailsUpdates: DraperyItemDetailsFieldsPartial = {
            ...res,
          };

          if (pleatTypesWithPricing) {
            const ripplefoldPleat = pleatTypesWithPricing.find(
              (pleat) => pleat.id === 'ripplefold' && pleat.price === ''
            );
            const currentPath = window.location.pathname;
            if (!isEstimateSettingsReadOnly && ripplefoldPleat && currentPath !== '/myshop') {
              setActiveTabIndex(1);
            }
          }

          const supplierName = getSelectedName({
            list: suppliers as [],
            findByKey: 'id',
            findValue: itemUpdates.supplierId,
            nameField: 'displayName',
          });

          const pricingTypeName = getSelectedName({
            list: draperyPricingTypes as [],
            findByKey: 'key',
            findValue: draperyItemDetailsUpdates.pricingTypeId,
            nameField: 'label',
          });

          const partialWidthRoundUpTypeName = getSelectedName({
            list: draperyWidthRoundUpTypes as [],
            findByKey: 'key',
            findValue: draperyItemDetailsUpdates.partialWidthRoundUpTypeId,
            nameField: 'label',
          });
          copyDispatch({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...itemUpdates,
              supplierName,
            },
          });
          dispatch({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...itemUpdates,
              supplierName,
            },
          });
          copyDispatchItemDetails({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...draperyItemDetailsUpdates,
              pricingTypeName,
              partialWidthRoundUpTypeName,
            },
          });
          dispatchItemDetails({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...draperyItemDetailsUpdates,
              pricingTypeName,
              partialWidthRoundUpTypeName,
            },
          });
        })
        .catch((err) => {
          console.log(`error fetching drapery item: ${err}`);
        });
    } else {
      const pricingTypeName = getSelectedName({
        list: draperyPricingTypes as [],
        findByKey: 'key',
        findValue: draperyItemDetailsFields.pricingTypeId,
        nameField: 'label',
      });
      const clientPricingAction =
        pricingTypeName === PricingType.Retail
          ? ClientPricingAction.Discount
          : ClientPricingAction.MarkUp;
      copyDispatchItemDetails({
        type: 'updateFormFields',
        formFieldUpdates: {
          pricingTypeName,
          clientPricingAction,
        },
      });
      dispatchItemDetails({
        type: 'updateFormFields',
        formFieldUpdates: {
          pricingTypeName,
          clientPricingAction,
        },
      });
    }
  }, [itemId]);

  useEffect(() => {
    if (errorElementId) {
      const errorElement = document.getElementById(errorElementId);
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        errorElement.focus();
      }
    }
  }, [errorElementId]);
  const handleNextChange = () => {
    if (isEstimateSettingsReadOnly) {
      return;
    }
    if (activeTabIndex < 2) {
      setActiveTabIndex(activeTabIndex! + 1);
    }
  };

  // MIXPANEL TRACKING ***
  useEffect(() => {
    const index_view_relation: any = {
      0: MixpanelEvents.MY_SHOP_FABRICATION_DETAILS,
      1: MixpanelEvents.MY_SHOP_FABRICATION_PRICING,
      2: MixpanelEvents.MY_SHOP_FABRICATION_SETTINGS,
    };
    trackView(index_view_relation[activeTabIndex], {});
  }, [activeTabIndex]);

  useEffect(() => {
    if (isModalOpen && itemId) {
      trackView(MixpanelEvents.MY_SHOP_FABRICATION, {});
    }
  }, [isModalOpen]);
  /** END OF MIXPANEL TRACKING *** */

  return (
    <>
      <Prompt
        message={(location: any): string | boolean => {
          if (isModalOpen) {
            showEditWorkOrderConfirm();
            return false;
          } else {
            window.location.replace('/myshop');
            return true;
          }
        }}
      />
      <PageDimmer uiActive={isModalOpen} />
      <ModalItem
        data-qa="my-shop-drapery-item-modal"
        uiActive={isModalOpen}
        uiOnRequestClose={() => {
          return;
        }}
        uiDefaultSizes={false}
      >
        <ValidationFormDrapery
          uiOnSubmit={handleSubmitForm}
          uiReportValidityMode="firstInvalid"
          uiOnInvalidElem={handleInvalidElem}
          onKeyPress={handleKeyPressForm}
          uiPadding={false}
          className="h-full"
        >
          <ModalHeader className="border-0">
            <div className="flex justify-between w-full pb-2 border-b-8 border-twSecondary">
              {getModalTitle()}
            </div>
          </ModalHeader>

          <ItemModalContent className="mb-8" style={{ marginTop: '-20px' }}>
            <PopoverScrollContext.Provider value={areaScrollInfo}>
              <ItemTabs
                selectedIndex={activeTabIndex}
                onSelect={selectTab}
                forceRenderTabPanel
                className="flex flex-col flex-1 h-full"
              >
                <TabList>
                  <Tab data-qa="my-shop-drapery-estimate-settings-tab">Estimate Settings</Tab>
                  <Tab data-qa="my-shop-drapery-pricing-tab" disabled={!!isEstimateSettingsReadOnly}>
                    Pricing
                  </Tab>
                  <Tab
                    data-qa="my-shop-drapery-construction-settings-tab"
                    disabled={!!isEstimateSettingsReadOnly}
                  >
                    Construction Settings
                  </Tab>
                  {activeTabIndex === 1 && (
                    <Tab
                      disabled
                      style={{
                        border: 'none',
                        background: '#FDF2DC',
                        float: 'right',
                        marginTop: '-4px',
                        borderRadius: '8px',
                        gap: '12px',
                        color: '#9C6B08',
                        fontSize: '14px',
                        fontWeight: '500',
                        lineHeight: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        paddingInline: '10px',
                        height: '36px',
                        width: '263px',
                      }}
                    >
                      <PricingAlert
                        style={{
                          padding: '3.24px',
                          width: '22px',
                          height: '22px',
                          top: '11px',
                          left: '15px',
                          gap: '0px',
                          borderRadius: '6px',
                          opacity: '0px',
                          backgroundColor: '#FFC043',
                        }}
                      />
                      All pricing fields are REQUIRED
                    </Tab>
                  )}
                </TabList>
                {renderDetails()}
                {renderPricing()}
                {renderConstructionSettings()}
              </ItemTabs>
            </PopoverScrollContext.Provider>
          </ItemModalContent>

          <ModalActions>
            <CancelButton
              data-qa="my-shop-drapery-cancel-button"
              type="button"
              uiColor="secondary"
              onClick={onClose}
              className="cancel_btn rounded-lg mr-auto block shadow-none"
            >
              {isEstimateSettingsReadOnly ? 'Close' : 'Cancel'}
            </CancelButton>
            {!isEstimateSettingsReadOnly &&
              (activeTabIndex >= 2 ? (
                <Button
                  data-qa="my-shop-drapery-save-button"
                  className="primary_btn rounded-lg border border-twBlue2 block shadow-none"
                  uiColor="primary"
                >
                  Save
                </Button>
              ) : (
                <CancelButton
                  data-qa="my-shop-drapery-next-button"
                  type="button"
                  className="cancel_btn rounded-lg block shadow-none"
                  uiColor="secondary"
                  onClick={handleNextChange}
                >
                  Next
                </CancelButton>
              ))}
          </ModalActions>
        </ValidationFormDrapery>
      </ModalItem>
      {/*  <ConfirmationCloseModal
                uiAcceptLabel="Yes"
                uiDeclineLabel="No"
                uiHeader="Confirmation"
                uiActive={isCloseModalActive}
                uiOnConfirm={() => {
                    dispatch({ type: "resetFormFields" });
                    setActiveTabIndex(0);
                    onModalClose();
                }}
                uiOnClose={() => setIsCloseModalActive(false)}
                uiOnRequestClose={() => setIsCloseModalActive(false)}
                uiCloseOnOutsideClick={true}
                uiCloseOnEsc={true}
            >
                Are you sure you want to exit without saving the changes?
            </ConfirmationCloseModal>*/}
    </>
  );
};

export default DraperyItemModal;
